import React from 'react';
import { Typography } from '@material-ui/core';

import { GridItems, Container, Header, Body } from './BaseBoxStyles';

export default function BaseBox({
  title,
  children,
  id,
  action,
  navLeft,
  navRight,
}: {
  title: string;
  children: any;
  id?: string;
  action?: React.ReactNode;
  navLeft?: React.ReactNode;
  navRight?: React.ReactNode;
}) {
  return (
    <GridItems xs={12} sm={6} md={6} lg={4} item id={id}>
      <Container>
        <Header>
          {navLeft && <div style={{ position: 'absolute', left: '4px' }}>{navLeft}</div>}
          <Typography variant="subtitle1" component="h4">
            {title}
          </Typography>
          {action && <div style={{ position: 'absolute', right: '4px' }}>{action}</div>}
          {navRight && <div style={{ position: 'absolute', right: '4px' }}>{navRight}</div>}
        </Header>
        <Body>{children}</Body>
      </Container>
    </GridItems>
  );
}
